import { SeverityLevel } from '@sentry/browser';

export enum MSRemoteLoggerSeverity {
  FATAL,
  ERROR,
  WARN,
  LOG,
  INFO,
  DEBUG
}

export enum MSRemoteLoggerCategory {
  INIT = 'init',
  REMOTE_LOGGER_SERVICE = 'remote-logger-service',
  PERSONS_SERVICE = 'persons-service',
  MAPS_SERVICE = 'maps-service',
  DELETE_SURVEY_SERVICE = 'delete-survey-service',
  PREFS_SERVICE = 'prefs-service',
  TIMES_SERVICE = 'times-service',
  API_OLD_SERVICE = 'api-old-service',
  MAPS_BING_SERVICE = 'maps-bing-service',
  AUTH_SERVICE = 'auth-service',
  MAPS_NATIVE_SERVICE = 'maps-native-service',
  CONNECTIVITY_SERVICE = 'connectivity-service',
  POST_SIGNUP_INITIALIZER_SERVICE = 'post-signup-initializer-service',
  POINTS_HELPER_SERVICE = 'points-helper-service',
  SENDER_SURVEY_SERVICE = 'sender-survey-service',
  DAILY_SURVEY_SERVICE = 'daily-survey-service',
  REGISTRATION_SERVICE = 'registration-service',
  SETUP_GUARD_SERVICE = 'setup-guard-service',
  MAPS_TRANSIT_SERVICE = 'maps-transit-service',
  SURVEY_GUARD_SERVICE = 'survey-guard-service',
  TRIP_SURVEY_SERVICE = 'trip-survey-service',
  EDIT_TIMES_SERVICE = 'edit-times-service',
  TRIP_SURVEY_INITIALIZER_SERVICE = 'trip-survey-initializer-service',
  ADD_SURVEY_SERVICE = 'add-survey-service',
  POSTER_SERVICE = 'poster-service',
  BADGE_SERVICE = 'badge-service',
  SIGNUP_SURVEY_SERVICE = 'signup-survey-service',
  GEOWATCHER_SERVICE = 'geowatcher-service',
  DEV_SYSTEMTIME_SERVICE = 'dev-systemtime-service',
  SURVEY_LOAD_SERVICE = 'survey-load-service',
  ROSTER_HELPER_SERVICE = 'roster-helper-service',
  STUDY_SERVICE = 'study-service',
  SQL_HELPER_SERVICE = 'sql-helper-service',
  PROXY_SURVEY_SERVICE = 'proxy-survey-service',
  SURVEY_PREPOPULATE_SERVICE = 'survey-prepopulate-service',
  SURVEY_SCHEMA_SERVICE = 'survey-schema-service',
  GIS_SERVICE = 'gis-service',
  SURVEY_BRANCH_SERVICE = 'survey-branch-service',
  SURVEY_TIME_LOGGER_SERVICE = 'survey-time-logger-service',
  STORAGE_SERVICE = 'storage-service',
  USER_STORAGE_SERVICE = 'user-storage-service',
  SURVEY_CLEAR_SERVICE = 'survey-clear-service',
  SURVEY_MATCHERS_SERVICE = 'survey-matchers-service',
  SURVEY_SETTER_SERVICE = 'survey-setter-service',
  SURVEY_MATCHER_SERVICE = 'survey-matcher-service',
  SURVEY_VALIDATE_SERVICE = 'survey-validate-service',
  MIGRATE_SERVER_ADDRESS_USE_CASE = "migrate-server-address-use-case",
  SURVEY_PAGE = 'survey-page',
  ADDRESS_SEARCH_COMPONENT = 'address-search-component',
  SURVEY_TRANSIT_MAP_PAGE = 'survey-transit-map-page',
  SURVEY_GEOCODER_DEVICE_PAGE = 'survey-geocoder-device-page',
  SURVEY_GEOCODER_BROWSER_PAGE = 'survey-geocoder-browser-page',
  SURVEY_MAP_DEVICE_PAGE = 'survey-map-device-page',
  SURVEY_MAP_BROWSER_PAGE = 'survey-map-browser-page',
  ADD_TIMES_DEVICE_PAGE = 'add-times-device-page',
  ADD_TIMES_BROWSER_PAGE = 'add-times-browser-page',
  ADD_STOP_DEVICE_PAGE = 'add-stop-device-page',
  ADD_STOP_BROWSER_PAGE = 'add-stop-browser-page',
  ADD_START_DEVICE_PAGE = 'add-start-device-page',
  ADD_START_BROWSER_PAGE = 'add-start-browser-page',
  LD_TRIPS_LD_PAGE = 'ld-trips-ld-page',
  EDIT_VET_PAGE = 'edit-vet-page',
  SETUP_PERSON_PAGE = 'setup-person-page',
  EDIT_VERIFY_DEVICE_PAGE = 'edit-verify-device-page',
  SETUP_CONTACT_PAGE = 'setup-contact-page',
  EDIT_VERIFY_BROWSER_PAGE = 'edit-verify-browser-page',
  LD_MAP_REGION_PAGE = 'ld-map-region-page',
  SETUP_SIGNUP_PAGE = 'setup-signup-page',
  SETUP_SIGNUP_DETAIL_PAGE = 'setup-signup-detail-page',
  SETUP_LOCALE_PAGE = 'setup-locale-page',
  SETUP_CALL_CENTER_PAGE = 'setup-call-center-page',
  ROSTER_TRIPS_LD_PAGE = 'roster-trips-ld-page',
  BROWSER_GEOCODER_PAGE = 'browser-geocoder-page',
  ROSTER_PERMISSION_ERROR_PAGE = 'roster-permission-error-page',
  ROSTER_FEEDBACK_PAGE = 'roster-feedback-page',
  ROSTER_HOME_PAGE = 'roster-home-page',
  ROSTER_MAP_ROUTE_DEVICE_PAGE = 'roster-map-route-device-page',
  ROSTER_DASHBOARD_PAGE = 'roster-dashboard-page',
  ROSTER_MAP_ROUTE_BROWSER_PAGE = 'roster-map-route-browser-page',
  ROSTER_TRIPS_PAGE = 'roster-trips-page',
  ROSTER_MENU_PAGE = 'roster-menu-page',
  BROWSER_UNSUPPORTED_PAGE = 'browser-unsupported-page',
  ROSTER_LOG_PAGE = 'roster-log-page',
  BROWSER_ROSTER_PAGE = 'browser-roster-page'
}

export type MSRemoteLoggerPrimitive = string | number | boolean | null | undefined;

export type MSRemoteLoggerData = {
  [key: string]:
    | MSRemoteLoggerPrimitive
    | MSRemoteLoggerData
    | ReadonlyArray<MSRemoteLoggerPrimitive | MSRemoteLoggerData>;
};

export function mapMSSeverityToSentrySeverity(severity: MSRemoteLoggerSeverity): SeverityLevel {
  switch (severity) {
    case MSRemoteLoggerSeverity.FATAL:
      return 'fatal';
    case MSRemoteLoggerSeverity.ERROR:
      return 'error';
    case MSRemoteLoggerSeverity.WARN:
      return 'warning';
    case MSRemoteLoggerSeverity.LOG:
      return 'log';
    case MSRemoteLoggerSeverity.INFO:
      return 'info';
    case MSRemoteLoggerSeverity.DEBUG:
      return 'debug';
    default:
      return 'info';
  }
}
